
// Dev specific bounds
export enum DevValidationConstants {
    backupTapeTBMin = 0,
    backupTapeRetrTBMin = 0,
    diskUsedTBMin = 0,
    hsmAndSmsTapeTBMin = 0,
    hsmAndSmsTapeRetrTBMin = 0,
    mipsMin = 0,
}

// Prod specific bounds
export enum ProdValidationConstants {
    backupTapeTBMin = 1,
    backupTapeRetrTBMin = 1,
    diskUsedTBMin = 1,
    hsmAndSmsTapeTBMin = 1,
    hsmAndSmsTapeRetrTBMin = 1,
    mipsMin = 100,
}

// Env independent bounds
export enum ValidationConstants {
    batchHrsMax = 168,
    batchHrsMin = 1,
    dataTransferOutGBMax = 10000,
    dataTransferOutGBMin = 0,
    diskUsedTBMax = 5000,
    envCountMax = 25,
    envCountMin = 0,
    mipsMax = 500000,
    nameLenMax = 128,
    nameLenMin = 2,
    oltpHrsMax = 168,
    oltpHrsMin = 1,
}

